<template>
<div >
   <el-row class="table-grid-content">
			<el-col :span="3" >
				<el-input v-model="selecttypeName" placeholder="请输入操作者"></el-input>
			</el-col>
      <el-col :span="3" style="margin-left:0.5rem;">
				 <el-select v-model="selectEnabled" placeholder="请选择操作类型">
           <el-option key="" label=""  value="" >全部</el-option>
           <el-option key="1" label="登录"  value="1" >登录</el-option>
           <el-option key="2" label="添加"  value="2" >添加</el-option>
           <el-option key="3" label="修改"  value="3" >修改</el-option>
           <el-option key="4" label="删除"  value="4" >删除</el-option>
       
      </el-select>
			</el-col>
			<el-col :span="3" class="grid" :gutter="1" style="margin-left:0.5rem;">
				<el-button type="success" @click="selectinit" icon="el-icon-search">搜索</el-button>
			</el-col>			
		</el-row>
  <el-table :data="purchaserecordsData" border style="width: 100%;margin-top: 1rem;">
    <el-table-column prop="userName" label="操作者"></el-table-column>
    <el-table-column prop="ipAddress" label="IP地址"></el-table-column>
    <el-table-column prop="operateTypeString" label="操作类型"></el-table-column>
    <el-table-column prop="operateConent" label="操作内容" :formatter="formatOperateConent"> </el-table-column>
    <el-table-column prop="insertDateString" label="操作时间">
      
    </el-table-column>   
    
 </el-table>


  <el-pagination
    @size-change="sizeChange"
    @current-change="currentChange"
    :page-sizes="[10]"   
    :page-size="page.pageSize"
    layout="total, sizes, prev, pager, next"
    :total="page.totalRecords">
  </el-pagination>
  </div>

</template>

<script>
export default {
  data(){
    return{
      value:false,
      show:false,
       selecttypeName:"",
      purchaserecordsData:[],
      selectEnabled:"",
      page:{
        pageSize: 10, //每页条数,  默认10条
        totalRecords: 0, //总条数
        totalPages: 0, //总页数
        pageNum:0
      },
       apiUrl:''  
    }
  },
  created(){
 this.apiUrl = localStorage.aipUrl
},

  mounted(){
    this.init();
   
  },
  methods:{
    formatOperateConent(row, column){
       if(row.operateConent!=null){
        return row.operateConent.split('：')[0];
       }else{
         return row.operateConent;
       }
        
    },
    selectinit(){
      this.page.pageNum=0;
      this.init();
    },
    
    init(){
      this.purchaserecordsData=[];
      let {pageNum,pageSize}=this.page;
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageJournal/findManageJournal?`+(new Date()).valueOf(),
          data: {
            pageNum: this.page.pageNum,
            userName: this.selecttypeName,
            pageSize: this.page.pageSize,
            operateType:this.selectEnabled

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
            this.page.totalRecords=res.data.data.totalRecords; //总条数
            const studentArray=res.data.data.list;
            this.purchaserecordsData=studentArray;
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })
    

    },
    // 每页显示多少条数据
sizeChange(val) {
  this.page.pageSize = val;
  this.init();
},
//翻页
currentChange(val) {
  this.page.pageNum=val-1;
  console.log(this.page.pageNum);
  this.init();
},
  }
}
</script>

<style scoped>


.el-table /deep/ th{
    background-color: #EEEFF1;
}

</style>


// WEBPACK FOOTER //
// src/views/journalList.vue